// extracted by mini-css-extract-plugin
module.exports = {"Auth":"_2YUr1vYMbwujw6K1HuakLc","AuthForm":"_2Xb4FWkkKJQrepEV2dgFau"};